import { useEffect } from 'react';
import useDealerProvincePricing from '../../../utils/hooks/useDealerProvincePricing';
import { INVENTORY_CALCULATOR } from '../constants';
import { createAndHydrateCalculator, deleteCalculator, primaryCalculatorId, updateCalculatorField, } from '../../../core/reducers/financialCalculators';
import { useAppDispatch } from '../../../core/utils';
const useInventoryPaymentCalculatorEffect = () => {
    const dispatch = useAppDispatch();
    const { isSellingPriceProvince } = useDealerProvincePricing();
    useEffect(() => {
        dispatch(createAndHydrateCalculator(primaryCalculatorId, INVENTORY_CALCULATOR));
        return () => {
            dispatch(deleteCalculator(INVENTORY_CALCULATOR));
        };
    }, [dispatch]);
    // sync dealer province pricing flag
    useEffect(() => {
        dispatch(updateCalculatorField({
            id: INVENTORY_CALCULATOR,
            field: { overriddenIsSellingProvince: isSellingPriceProvince },
        }));
    }, [dispatch, isSellingPriceProvince]);
};
export default useInventoryPaymentCalculatorEffect;
